export const Maximize = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 3H29V12" stroke="currentColor" stroke-width="2"/>
<path d="M18.707 13.2891L29 3" stroke="currentColor" stroke-width="2"/>
<path d="M12 29L3 29L3 20" stroke="currentColor" stroke-width="2"/>
<path d="M13.293 18.7109L3 29" stroke="currentColor" stroke-width="2"/>
</svg>`;
